var style = {"z-form-field-proxy":"z-form-field-proxy","z-form-field-proxy__container":"z-form-field-proxy__container","z-textarea":"z-textarea","z-form-field-proxy--has-focus":"z-form-field-proxy--has-focus","z-form-field-proxy--has-error":"z-form-field-proxy--has-error","z-select__arrow":"z-select__arrow"};

export { style as default };
//# sourceMappingURL=FormFieldProxy.module.scss.js.map
